import React, { ReactElement } from 'react'
import styled from 'styled-components'
import colors from '../../lib/colors'
import { IGiftItemResponse } from '../../types/itemTypes'
import { StateAction } from '../../types/typeAliases'
import { renderHTML } from '../../helpers/HTMLRenderer'
import ItemPopup from './ItemPopup'

const Title = styled.section`
  font-size: 15px;
  font-weight: bold;
`
const DateInfo = styled.section`
  font-size: 13px;
  font-weight: bold;
`
const Restrictions = styled.div`
  hr {
    border-top: 1px solid ${colors.lightGray};
    margin: 18px 0;
  }
  strong {
    display: block;
    margin-bottom: 2px;
  }
`
const getValidityText = (validity: number | null | undefined): string => {
  if (validity || validity === 0) {
    return `Valid for ${validity} month${validity === 1 ? '' : 's'}`
  }
  return ''
}
interface IDetailsProps {
  giftItem: IGiftItemResponse
  showDetails: boolean
  setShowDetails: StateAction<boolean>
  embedMode: boolean
}
function Details(props: IDetailsProps): ReactElement | null {
  const {
    giftItem: {
      name, validity, details, terms, startInfo, restrictions,
    },
    showDetails,
    setShowDetails,
    embedMode,
  } = props

  return (
    <ItemPopup
      showPopup={showDetails}
      setShowPopup={setShowDetails}
      embedMode={embedMode}
    >
      <Title>{name}</Title>
      <DateInfo>{startInfo || getValidityText(validity)}</DateInfo>
      {details && <section>{renderHTML(details)}</section>}
      {terms && <section>{renderHTML(terms)}</section>}
      {restrictions && (
        <Restrictions>
          <hr />
          <strong>Important information</strong>
          <section>{renderHTML(restrictions)}</section>
        </Restrictions>
      )}
    </ItemPopup>
  )
}
export default Details
